const module = { name: 'home/desktop/theatersModule', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { fd_location as fd_location_updateLocation_getLocation } from 'require-global';

const { updateLocation, getLocation } = fd_location_updateLocation_getLocation;


import { default as locationFormCreation } from 'swug-fdRequire-call:fd-location/form/creation';



import { default as shared_utils_urlHelpers_generateTspLink } from 'swug-fdRequire-call:shared/utils/urlHelpers';

const { generateTspLink } = shared_utils_urlHelpers_generateTspLink;


import { default as getZip } from 'swug-fdRequire-call:desktop/global/getZip';



import { default as theater_shared_locationHelpers_formatTheaterDistance } from 'swug-fdRequire-call:theater/shared/locationHelpers';

const { formatTheaterDistance } = theater_shared_locationHelpers_formatTheaterDistance;


const Selectors = Object.freeze({
    LOCAL_MOVIES_LINK: '#local-movies-link',
    LOCATION: '#theaters-module-location',
    MODULE_WRAP: '#theater-module-wrap',
    SEE_MORE_THEATERS: '#theaters-module-see-more',
    THEATER_ITEM: '.js-theaters-module-theater',
    THEATERS_PLACEHOLDER: '#theater-module-placeholder',
})


const Styles = Object.freeze({
    HIDE: 'hide',
    SELECTED: 'theaters-module__theater-link--selected',
    THEATERS_ONLY: 'theaters-module--theaters-only',
})
function onTheaterClick() {
    const { id } = this.dataset;
    track({
        event: EventTypes.THEATER_MODULE_THEATER_CLICKED,
        id,
    });
}
function onLocationChange() {
    $(Selectors.THEATERS_PLACEHOLDER).html(swig.render('_theatersModuleCardsPlaceholder'));
    init();
}
function onDone(data) {
    if (!Array.isArray(data.theaters) || data.theaters.length === 0) {
        $(Selectors.THEATERS_PLACEHOLDER).html(swig.render('_theatersModule'));
        return;
    }
    if (data.error) {
        onFail(data.error);
        return;
    }
    const $theatersPlaceholder = $(Selectors.THEATERS_PLACEHOLDER);
    data.theaters.forEach(theater => formatTheaterDistance(theater, 1, true));
    const markup = swig.render('_theatersModule', data);
    $theatersPlaceholder.html(markup);
    $(Selectors.THEATER_ITEM, $theatersPlaceholder).on('click', onTheaterClick);
}
function onFail(err) {
    debugLog.error(module.name, 'API Fail', err);
    $(Selectors.MOVIES_PLACEHOLDER).html('');
    $(Selectors.THEATERS_PLACEHOLDER).html(swig.render('_errorMessage', {
        msg: 'There was an error retrieving nearby cinemas.'
    }));
}
function init() {
    debugLog.log(module.name, 'init');
    $(Selectors.MODULE_WRAP)
        .addClass(Styles.THEATERS_ONLY);
    const location = getLocation();
    updateLocation(location);
    getZip.init(Selectors.LOCAL_MOVIES_LINK);
    locationFormCreation.init({
        dropdown: {
            name: 'desktopHomeNearTheatersModule',
            relativeParent: Selectors.LOCATION,
        }
    });
    const [city, state] = location?.name?.split(', ') || [];
    let locationParam;
    if (location.postalCode) {
        locationParam = location.postalCode;
    }
    else if (city && state) {
        locationParam = `${city.replace(/\s/, '-').toLowerCase()}_${state.toLowerCase()}`;
    }
    if (locationParam) {
        $(Selectors.SEE_MORE_THEATERS).attr('href', generateTspLink(locationParam));
    }
    locationFormCreation.attach(onLocationChange);
    xhr.ajax({
        url: links.napiHomeTheaterModule(null, {
            ...location?.params,
        }),
        method: 'GET'
    })
        .done(onDone)
        .fail(onFail);
}
module.exports = {
    init,
};
export default module.exports;